import React, {useContext, useState} from "react";
import {contactLinks} from "../constants";
import { ThemeContext } from "../themeProvider";
import Swal from 'sweetalert2';

const Contact = () => {
    const theme = useContext(ThemeContext);
    const darkMode = theme.state.darkMode;

    const formInitialDetails = {
        name: '',
        email: '',
        message: ''
    }
    const [formDetails,
        setFormDetails] = useState(formInitialDetails);
    const [buttonText,
        setButtonText] = useState('Send');
    const [status,
        setStatus] = useState({});

  const onFormUpdate = (category, value) => {
    // console.log('CCCCCCCCC', category, value)
        setFormDetails({
            ...formDetails,
            [category]: value
        })
    }

    const handleSubmit = async(e) => {
        e.preventDefault();
        setButtonText("Sending...");
        let response = await fetch("https://porfolioserver.onrender.com/contact", {
            method: "POST",
            headers: {
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify(formDetails)
        });
        setButtonText("Send");
      let result = await response.json();
      // console.log('tt', formInitialDetails);
        setFormDetails(formInitialDetails);
        if (result.code === 200) {
          setStatus({ succes: true, message: 'Message sent successfully' });
            Swal.fire({
                position: 'top-end',
                icon: 'success',
                title: 'Your message has been sent',
                showConfirmButton: false,
                timer: 1500
            });
        } else {
            setStatus({ succes: false, message: 'Something went wrong, please try again later.' });
            Swal.fire({
                icon: 'error',
                title: 'Something went wrong, please try again later....',
                text: 'Something went wrong!',
                footer: '<a href="">Why do I have this issue?</a>'
            })
        }
    };

    return (
        <div
            id="contact"
            className={darkMode
            ? "bg-gray-100 pt-16 md:h-screen"
            : "bg-black pt-16 text-white md:h-screen"}>
            <div className="max-w-7xl mx-auto x-4 sm:px-6 lg:px-8 px-4 ">
                <h2 className="text-5xl font-bold px-4 md:px-0 text-center z-0">
                    Contact
                </h2>
                <div>
                    <br/>
                    <br/> {/* <h4 className="mt-12 text-3xl font-semibold text-blue-500">
        Connect with me
      </h4> */}
                    <p className="text-gray-500 text-xl">
                        If you want to know more about me or would just like to say hello,
                        <br/>
                        Please feel free to send me a message. I'd love to hear from you.
                    </p>
                    <br/>
                </div>
                <div
                    className="flex justify-between items-center md:items-stretch  flex-col md:flex-row pb-24">
                    <div className="w-full md:pr-8">
                        <form onSubmit={handleSubmit}>
                            <div className="my-6">
                                <label
                                    htmlFor="name"
                                    className={darkMode
                                    ? "block mb-2 text-lg font-medium text-gray-900"
                                    : "block mb-2 text-lg font-medium text-white"}>
                                    Name
                                </label>
                                <input
                                    type="text"
                                    id="name"
                                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    placeholder="Enter your name"
                                    value={formDetails.name}
                                    onChange={(e) => onFormUpdate('name', e.target.value)}/>
                            </div>
                            <div className="mb-4">
                                <label
                                    htmlFor="email"
                                    className={darkMode
                                    ? "block mb-2 text-lg font-medium text-gray-900"
                                    : "block mb-2 text-lg font-medium text-white"}>
                                    Email
                                </label>
                                <input
                                    type="email"
                                    id="email"
                                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    placeholder="Enter your email"
                                    value={formDetails.email}
                                    onChange={(e) => onFormUpdate('email', e.target.value)}/>
                            </div>
                            <div className="mb-4">
                                <label
                                    htmlFor="message"
                                    className={darkMode
                                    ? "block mb-2 text-lg font-medium text-gray-900"
                                    : "block mb-2 text-lg font-medium text-white"}>
                                    Message
                                </label>
                                <textarea
                                    id="message"
                                    className="bg-gray-50 border border-gray-300 text-gray-900 h-28 w-full text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    placeholder="Enter your message"
                                    value={formDetails.message}
                                    onChange={(e) => onFormUpdate('message', e.target.value)}/>
                            </div>
                            <div className="flex justify-between ">
                                <div className="underline">
                                    <a href="mailto:esraa.bnt96@gmail.com">
                                        Send me email directly
                                    </a>
                                </div>
                                <button
                                    className="bg-indigo-500 text-white px-4 py-2 w-40 rounded-md hover:bg-indigo-400">
                    <span>{buttonText}</span>
                                </button>
                            </div>
                        </form>
                    </div>
                    <div className="w-full flex flex-col md:items-center mt-12 md:mt-6">
                        <h1 className="text-3xl font-bold">Email</h1>
                        <a
                            href="hello"
                            className="mb-12 mt-4 font-semibold text-blue-700 block uppercase">
                            esraa.bnt96@gmail.com
                        </a>
                        <h1 className="text-3xl  font-bold">Address</h1>
                        <a
                            href="hello"
                            className="mt-4  mb-12 md:text-right font-semibold text-blue-700 block uppercase">
                            Amman - Jordan
                        </a>
                        <h1 className="text-3xl  font-bold">Social Media</h1>
                        <ul className="flex">
                            {contactLinks.map((el, idx) => (
                                <a
                                    key={idx}
                                    href={el.link}
                                    className="md:ml-6 md:mr-0 mr-6 cursor-pointer mt-4 hover:scale-125 flex flex-col justify-center items-center">
                                    <img alt="" src={el.url}/> {/* <p className="text-md mt-2 hover:hidden">{el.name}</p> */}
                                </a>
                            ))}
                        </ul>
                    </div>
                </div>
        </div>
            <div
                className={darkMode
                ? "w-full bg-white text-black text-lg py-3 flex justify-center md:mt-20"
                : "w-full bg-gray-900 text-white text-lg py-3 flex justify-center md:mt-20"}>
                ©2022 Made with
                <div className="text-red-500 px-2 text-2xl">&#10084;</div>
                by Esraa Banat
            </div>
        </div>
    );
};

export default Contact;
